import { useEffect, useRef } from "react";

/**
 * Reveal-on-scroll. Attach the returned ref to a container; any descendant
 * with the `.reveal` class gets `.is-visible` added when it scrolls into view.
 */
const useReveal = () => {
  const ref = useRef(null);

  useEffect(() => {
    const root = ref.current;
    if (!root) return;

    const SELECTOR = ".reveal, .reveal-stagger";
    const self =
      root.classList.contains("reveal") || root.classList.contains("reveal-stagger")
        ? [root]
        : [];
    const targets = [...self, ...root.querySelectorAll(SELECTOR)];

    if (!("IntersectionObserver" in window) || targets.length === 0) {
      targets.forEach((el) => el.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    targets.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return ref;
};

export default useReveal;
